//select post to be generated into an AI report
import React, { useState, useEffect, useCallback } from 'react'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useNavigate } from 'react-router-dom'
import { db, auth } from '../Firebase/FirebaseConfig'
import {
  getDoc,
  getDocs,
  collection,
  doc,
  orderBy,
  query
} from 'firebase/firestore'
import '../Styling/Project.css'
import '../Styling/Default.css'
import generateReport from '../Components/GenerateReport'

import {
  Button,
  Container,
  CircularProgress,
  Backdrop,
  Grid,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  FormLabel,
  FormControlLabel,
  FormGroup,
  FormControl,
  Paper,
  IconButton,
  Snackbar,
  Box,
  Typography,
  useMediaQuery,
  Badge
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { ArrowDownward, ArrowUpward, ArrowBack } from '@mui/icons-material'
import Navi from '../Components/Navi'
// import CheckBox from '../Components/Checkbox'
import SaveReport from '../Components/SaveReport'
import UpdateReport from '../Components/UpdateReport'

const UserPosts = () => {
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const [user, loading, error] = useAuthState(auth)
  const [allProjects, setAllProjects] = useState([])

  // const [CaptionPairs, setCaptionPairs] = useState([]) //holds caption & image pairs
  const [selectedData, setSelectedData] = useState({})

  const [selectedProject, setSelectedProject] = useState(null) //current project being viewed
  const [projectAscend, setProjectAscend] = useState(true) //toggle ascending vs descending dates
  const [checkProject, setCheckProject] = useState({})

  let tempPosts
  let emptyProject

  const mobile = useMediaQuery('(max-width:600px)')

  //loads user projects from firebase
  const getUserProjects = async () => {
    try {
      const projects = []
      const userRef = doc(db, 'users', user.uid)
      const projectsRef = collection(userRef, 'projects')
      const q = query(projectsRef, orderBy('created-date', 'desc'))
      const projSnapshot = await getDocs(q)

      projSnapshot.forEach((doc) => {
        const projDate = doc.data()['created-date'].toDate()

        if (doc.data().posts != null) {
          tempPosts = doc.data().posts
          emptyProject = false
        } else {
          tempPosts = 'No Posts'
          emptyProject = true
        }
        const project = {
          id: doc.id,
          title: doc.data().title,
          date: projDate,
          posts: tempPosts,
          empty: emptyProject
        }
        projects.push(project)
      })
      setAllProjects(projects)
      let tmp = []
      projects.forEach((project, index) => {
        tmp[index] = []
      })
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (loading) return
    getUserProjects()
  }, [user])

  const handleAscend = () => {
    setProjectAscend(!projectAscend)
  }

  const handleProjectBack = () => {
    setSelectedProject(null)
  }

  useEffect(() => {
    let tmp = [...allProjects]
    if (projectAscend) {
      tmp = tmp.sort((a, b) => b.date - a.date)
    } else {
      tmp = tmp.sort((a, b) => a.date - b.date)
    }
    setAllProjects(tmp)
  }, [projectAscend])

  const viewReport = (report) => {
    let descriptions = Object.values(selectedData)
      .filter((pair) => pair.caption)
      .map((pair) => pair.caption)
    navigate('/ViewReport', {
      state: {
        report: report,
        edit: true,
        selectedData: descriptions
      }
    })
  }

  const handleSelect = (id, index, value, type, checked) => { //selects a post
    if (checked) {
      setSelectedData((prev) => {
        let tmp = { ...prev }
        tmp[`${id}_${index}`] = { ...tmp[`${id}_${index}`], [type]: value }
        return tmp
      })
    } else {
      setSelectedData((prev) => {
        let tmp = { ...prev }
        delete tmp[`${id}_${index}`][type]
        if (Object.keys(tmp[`${id}_${index}`]).length == 0) {
          delete tmp[`${id}_${index}`]
        }
        return tmp
      })
    }
  }

  const selectAll = (checked) => { //selects all posts in current project
    let project = allProjects[selectedProject]
    project.posts.map((post, index) => {
      if (checked) {
        handleSelect(project.id, index, post.description, 'caption', checked)
        handleSelect(project.id, index, post['image-url'], 'image-url', checked)
      } else {
        setSelectedData((prev) => {
          let tmp = { ...prev }
          delete tmp[`${project.id}_${index}`]
          return tmp
        })
      }
    })
  }

  const isChecked = (type, value) => { //checks if a value is selected
    return Object.values(selectedData)
      .map((data) => data[type])
      .includes(value)
  }

  const allChecked = () => { //checks if ALL posts in a project are selected
    let project = allProjects[selectedProject]
    return project.posts.every((post, index) => {
      let indexId = `${project.id}_${index}`
      if (selectedData[indexId] == undefined) {
        return false
      } else {
        if (selectedData[indexId].caption !== post.description) {
          return false
        }
        if (selectedData[indexId]['image-url'] !== post['image-url']) {
          return false
        }
        return true
      }
    })
  }

  const handleReset = () => {
    setSelectedData({})
  }

  const RenderPosts = () => {
    let showCheckbox
    let item = allProjects[selectedProject]
    let index = selectedProject
    return (
      <>
        {item.empty == true ? (
          <div>
            <b>No Posts</b>
          </div>
        ) : (
          <>
            {item.posts.map((post, index) => {
              if (post.description === undefined) {
                showCheckbox = false
              } else {
                showCheckbox = true
              }
              let date = new Date(post['created-date'].toDate()).toDateString()
              return (
                <Paper sx={{ marginBottom: '20px', width: '100%' }} key={index}>
                  <Box
                    sx={{
                      display: 'flex',
                      padding: '15px 15px',
                      borderBottom: '1px solid grey'
                    }}
                  >
                    <Typography sx={{ flexGrow: 1, textAlign: 'right' }}>
                      {date}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      padding: '15px 15px',
                      backgroundColor: isChecked('image-url', post['image-url'])
                        ? '#7bafd4'
                        : null
                    }}
                  >
                    <Checkbox
                      // type='checkbox'
                      sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                      id={post['image-url']}
                      value={post['image-url']}
                      onChange={(e) =>
                        handleSelect(
                          item.id,
                          index,
                          e.target.value,
                          'image-url',
                          e.target.checked
                        )
                      }
                      checked={isChecked('image-url', post['image-url'])}
                    />
                    <span>
                      <img className='image_box' src={post['image-url']} />
                    </span>
                  </Box>
                  {showCheckbox == true ? (
                    <Box
                      sx={{
                        padding: '15px 15px',
                        display: 'flex',
                        textAlign: 'left',
                        backgroundColor: isChecked('caption', post.description)
                          ? '#7bafd4'
                          : null
                      }}
                    >
                      <Checkbox
                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 } }}
                        // type='checkbox'
                        value={post.description}
                        onChange={(e) =>
                          handleSelect(
                            item.id,
                            index,
                            e.target.value,
                            'caption',
                            e.target.checked
                          )
                        }
                        checked={isChecked('caption', post.description)}
                      />
                      <span>{post.description}</span>
                    </Box>
                  ) : (
                    <>
                      {' '}
                      <div>No Description</div>
                    </>
                  )}
                </Paper>
              )
            })}
          </>
        )}
      </>
    )
  }

  let selectedDataLength = [].concat(
    ...Object.values(selectedData).map((pair) => Object.values(pair))
  ).length

  const FloatingActions = () => {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <IconButton onClick={() => handleReset()}>
          <CloseIcon sx={{ color: '#fff' }} />
        </IconButton>
        <Typography sx={{ flexGrow: 1 }}>
          {selectedDataLength <= 1
            ? '1 Item Selected'
            : `${selectedDataLength} Items Selected`}
        </Typography>
        <Button
          onClick={() => {
            setIsLoading(true)
            generateReport(selectedData).then((resp) => {
              console.log(resp)
              viewReport(resp)
            })
            // handleToggle()
          }}
        >
          Generate Report
        </Button>
      </Box>
    )
  }
  const showBadge = (id) => {
    //checks if project id exists in selected data
    return (
      Object.keys(selectedData).filter((string) => string.indexOf(id) > -1)
        .length == 0
    )
  }

  const SelectProjects = () => {
    return (
      <>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <Typography
            sx={{ flexGrow: 1, textAlign: 'left', fontWeight: 'bold' }}
          >
            Project Name
          </Typography>
          <Button
            onClick={() => handleAscend()}
            sx={{ textTransform: 'none' }}
            endIcon={projectAscend ? <ArrowUpward /> : <ArrowDownward />}
          >
            Date Created
          </Button>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}></Box>
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gridRowStart: '2' }}
        >
          {allProjects.map((project, index) => {
            let isSelected = false
            if (selectedProject == index) {
              isSelected = true
            }
            let dateString = new Date(project.date).toDateString()
            return (
              <Badge
                // invisible={checkProject[index].length == 0}
                invisible={showBadge(project.id)}
                color='primary'
                variant='dot'
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left'
                }}
              >
                <Paper
                  sx={{
                    display: 'flex',
                    width: '100%',
                    marginBottom: '10px',
                    backgroundColor: isSelected ? '#7bafd4' : null,
                    color: isSelected ? '#fff' : null,
                    padding: '10px 10px'
                  }}
                  key={`${project.title}-${index}`}
                  onClick={() => setSelectedProject(index)}
                >
                  <Typography
                    sx={{
                      flexGrow: 1,
                      textAlign: 'left',
                      fontWeight: 'bold'
                    }}
                  >
                    {project.title}
                  </Typography>
                  <Typography>{dateString}</Typography>
                </Paper>
              </Badge>
            )
          })}
        </Box>
      </>
    )
  }

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={selectedDataLength > 0}
        message={isLoading ? 'Generating Report...' : <FloatingActions />}
      />

      <Backdrop
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1
        }}
        open={isLoading}
      >
        <CircularProgress color='secondary' />
      </Backdrop>

      <div style={{ marginTop: '10px' }}>
        {mobile ? (
          <>
            {typeof selectedProject !== 'number' ? (
              <Box sx={{ width: '100%', borderBottom: '1px grey solid', paddingTop: '30px' }}>
                <Typography variant='h2' fontSize='40px'>Generate Report</Typography>
              </Box>
            ) : (
              <>
                <Box
                  sx={{
                    width: '100%',
                    borderBottom: '1px grey solid',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <IconButton onClick={() => handleProjectBack()}>
                    <ArrowBack />
                  </IconButton>
                  <Typography fontWeight={'bold'}>{allProjects[selectedProject].title}</Typography>
                </Box>
              </>
            )}
            <Container sx={{ marginBottom: '100px' }}>
              {typeof selectedProject !== 'number' ? (
                <>
                  <Box>
                    <SelectProjects />
                  </Box>
                </>
              ) : (
                <>
                  <Box>
                    {allProjects.length > 0 ? (
                      typeof selectedProject == 'number' ? (
                        <>
                        <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          paddingLeft: '20px',
                          alignItems: 'center'
                        }}
                      >
                        <Checkbox
                          id={`${selectedProject}_all`}
                          checked={allChecked()}
                          onChange={(e) => selectAll(e.target.checked)}
                        />
                        <Typography>Select all posts</Typography>
                      </Box>
                        <RenderPosts />
                        </>
                      ) : (
                        'Select a Project'
                      )
                    ) : (
                      <div>loading</div>
                    )}
                  </Box>
                </>
              )}
            </Container>
          </>
        ) : (
          <>
            <Box sx={{ width: '100%', borderBottom: '1px grey solid' }}>
              <Typography variant='h2'>Generate Report</Typography>
            </Box>
            <Container>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '40% auto'
                }}
              >
                {/* <Box> */}
                <SelectProjects />
                {/* </Box> */}

                <Box>
                  {allProjects.length > 0 ? (
                    typeof selectedProject == 'number' ? (
                      <>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            paddingLeft: '20px',
                            alignItems: 'center'
                          }}
                        >
                          <Checkbox
                            id={`${selectedProject}_all`}
                            checked={allChecked()}
                            onChange={(e) => selectAll(e.target.checked)}
                          />
                          <Typography>Select all posts</Typography>
                        </Box>
                        <RenderPosts />
                      </>
                    ) : (
                      'Select a Project'
                    )
                  ) : (
                    <div>loading</div>
                  )}
                </Box>
              </Box>
            </Container>
          </>
        )}
      </div>
    </>
  )
}
export default UserPosts
